import { inject, injectable } from 'inversify';
import CompanyDataSource from 'src/features/companies/data/CompanyDataSource';
import { CompanyCreditRepositoryInterface } from 'src/features/efektivaCredit/domain/repositories/CompanyCreditRepository.types';

@injectable()
class CompanyCreditRepository implements CompanyCreditRepositoryInterface {
  @inject(CompanyDataSource) private companyDataSource!: CompanyDataSource;

  async getCompanyCreditInfo(accessToken: string) {
    const companyResponse = await this.companyDataSource.getCurrentUserCompany({
      accessToken,
    });

    if (companyResponse.results.length === 0) {
      return null;
    }

    const creditData = companyResponse.results[0].credit_company[0];

    return {
      name: creditData.name,
      slugName: creditData.slug_name,
      amount: Number(creditData.amount),
      amountAvailable: Number(creditData.amount_available),
      created: creditData.created,
      modified: creditData.modified,
      closingDate: creditData.closing_date,
    };
  }
}

export default CompanyCreditRepository;
